import axios from "axios"


export const PartsService = Object.freeze({

  GetBaseUrl(){
    let partControllerUrl = window.appGlobals.API_URL + "Part/";
    return partControllerUrl;
  },
  FullPartDetails: function (accountId, userId, partId, audienceIds, oemPartCode = null, accountCustomerPartId = null) {
    let audienceIdQueryString = "";
    let i = 0;
    if(audienceIds){
        for(i; i < audienceIds.length; i++){
            audienceIdQueryString += `&audienceIds=${audienceIds[i]}`
        }
    }

    var reqUrl = `${this.GetBaseUrl()}FullPartDetails?accountId=${accountId}&userId=${userId}&partId=${partId}&oemPartCode=${oemPartCode}&audienceIds=${audienceIdQueryString}&accountCustomerPartId=${accountCustomerPartId}`;
    return axios.get(reqUrl);
  },
  GetMultiplePartDetails: function (costCenter, accountId, userId, myoemPartCodes) {
    var reqUrl = `${this.GetBaseUrl()}GetMultiplePartDetails?mcfCostCenterId=${costCenter}&accountId=${accountId}&userId=${userId}`;
    return axios.post(reqUrl,  myoemPartCodes);
  },
  ValidateParts: function (accountId, userId, partIds) {
    var reqUrl = `${this.GetBaseUrl()}ValidateParts?accountId=${accountId}&userId=${userId}`;
    return axios.post(reqUrl, partIds);
  },
  ValidatePartsWithoutPricing: function (mcfCostCenterId, accountId, partIds) {
    var reqUrl = `${this.GetBaseUrl()}ValidatePartsWithoutPricing?mcfCostCenterId=${mcfCostCenterId}&accountId=${accountId}`;
    return axios.post(reqUrl, partIds);
  }
})
